<template>
    <b-tab :title="$store.state.localization.data.mainPage.clients.tabs.roles"
            >
              <div
                class="row no-gutters"
                style="margin-left: 5px; margin-bottom: 5px"
              >
                <div class="col-5">
                  <b-form-select
                    v-model="roles.left.data"
                    :options="roles.left.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="rolesLeftRef"
                  ></b-form-select>
                </div>
                <div class="col-1 align-self-center" style="text-align: center">
                  <b-button-group vertical>
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectRoles"
                      >&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectAllRoles"
                      >&#62;&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectAllRoles"
                      >&#60;&#60;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectRoles"
                      >&#60;</b-button
                    >
                  </b-button-group>
                </div>
                <div class="col-5">
                  <b-form-select
                    v-model="roles.right.data"
                    :options="roles.right.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="rolesRightRef"
                  ></b-form-select>
                </div>
              </div>
      </b-tab>
  </template>
  
  <script>
  
  export default {
    name: "RolesTab",
    props: {
      allRoles: [],
    },
    data() {
      return {
        roles: {
          left: {
            data: [],
            values: [],
          },
          right: {
            data: [],
            values: [],
          },
        },
      };
    },
    created() {
      this.roles.left.data = [];
      this.roles.left.values = [];
      this.roles.right.data = [];
      this.roles.right.values = [];

      for (let i = 0; i < this.allRoles.length; i++) {
        this.roles.left.values.push({
            value: this.allRoles[i].id,
            text: this.allRoles[i].name,
          });
      }
    },
    methods: {
      getRoles() {
        const roles = [];

        for (let i = 0; i < this.roles.right.values.length; i++) {
          roles.push(this.roles.right.values[i].value);
        }

        return roles;
      },
      selectRoles() {
        for (let i = 0; i < this.roles.left.data.length; i++) {
          const columnIndex = this.roles.left.values.findIndex(
            (x) => x.value == this.roles.left.data[i]
          );

          this.roles.right.values.push(
            this.roles.left.values[columnIndex]
          );
          this.roles.left.values.splice(columnIndex, 1);
        }
      },
      selectAllRoles() {
        for (let i = 0; i < this.roles.left.values.length; i++) {
          this.roles.right.values.push(
            this.roles.left.values[i]
          );
        }

        this.roles.left.data = [];
        this.roles.left.values = [];
      },
      deselectRoles() {
        for (let i = 0; i < this.roles.right.data.length; i++) {
          const columnIndex = this.roles.right.values.findIndex(
            (x) => x.value == this.roles.right.data[i]
          );

          this.roles.left.values.push(
            this.roles.right.values[columnIndex]
          );
          this.roles.right.values.splice(columnIndex, 1);
        }
      },
      deselectAllRoles() {
        for (let i = 0; i < this.roles.right.values.length; i++) {
          this.roles.left.values.push(
            this.roles.right.values[i]
          );
        }

        this.roles.right.data = [];
        this.roles.right.values = [];
      },
    },
  };
  </script>
  